// extracted by mini-css-extract-plugin
module.exports = {"tablist":"footer_tablist__Fjjzs","tab":"footer_tab__DFm7m","tab_selected":"footer_tab_selected__eh8qp"};